import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import ThingQrcode from './thingQrcode';
import TopSlides from './topSlides';
import Chip from 'Chip';

class goodThing extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;
        const { globalGoodThing, productsRecommend = [] } = content;

        return (
            <div className={styles.goodThing}>
                <img src="https://x0.ifengimg.com/feprod/c/2023_1_17/16_21_21/1.png" className={styles.imageMark} />
                <Chip
                    id="195947"
                    type="recommend"
                    title="焦点图"
                    groupName="右边侧栏"
                    content={productsRecommend}
                    translate="handleProductsRecommend">
                    <TopSlides content={productsRecommend} />
                </Chip>
                <Chip id="200165" type="struct" title="全球好物" groupName="右边侧栏" content={globalGoodThing}>
                    <ThingQrcode />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(goodThing);
